import React, { useState, useEffect } from 'react';
// "Stop new trades today" switch for an intraday strategy. Open trades keep their stops, targets and square-off.
export default function PauseButton({ name, label }) {
  const [st, setSt] = useState(null); const [busy, setBusy] = useState(false);
  const load = async () => { try { const r = await fetch(`/opendrive/pause?strategy=${name}&t=${Date.now()}`, { cache: 'no-store' }); setSt(await r.json()); } catch (e) {} };
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [name]);
  const toggle = async () => {
    const on = !(st && st.paused);
    if (on && !window.confirm(`Stop new ${label || 'trades'} for the rest of today?\nOpen trades keep their stops, targets and square-off.`)) return;
    setBusy(true);
    try { const r = await fetch('/opendrive/pause', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ strategy: name, on }) }); setSt(await r.json()); load(); } catch (e) {}
    setBusy(false);
  };
  const p = st && st.paused;
  const at = p && st.since ? new Date(st.since.replace(' ', 'T')).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }) : '';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
      <button onClick={toggle} disabled={busy || !st} style={{ padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontWeight: 600,
        border: `1px solid ${p ? '#1D9E75' : '#E24B4A'}`, background: p ? 'rgba(29,158,117,0.08)' : 'rgba(226,75,74,0.08)', color: p ? '#1D9E75' : '#E24B4A' }}>
        {p ? 'Resume new trades' : 'Stop new trades today'}
      </button>
      <span style={{ fontSize: 13, color: 'var(--t2)' }}>{p ? `Paused by you${at ? ' at ' + at : ''} · open trades still managed` : 'Trading normally'}</span>
    </div>
  );
}
